// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { DropzoneArea } from 'material-ui-dropzone';
import { createTheme, ThemeProvider } from '@material-ui/core';

// Internal Dependencies
import Colours from '../../../styles/colours';
import Constants from '../../../common/constants';

const theme = createTheme({
  overrides: {
    MuiDropzoneArea: {
      root: { borderRadius: 12, padding: 4 },
      text: { color: Colours.Gray2, fontSize: 16, fontFamily: 'Inter' },
      icon: { color: Colours.Gray2 },
    },
    MuiChip: {
      label: { fontWeight: 500, fontFamily: 'Inter' },
    },
  },
});

const MDropzone = (props) => {
  const onAlert = (message, variant) => {
    if (variant === 'error') {
      toast.error(message);
      return;
    }

    if (variant === 'info') {
      toast.info(message);
      return;
    }

    if (variant === 'warning') {
      toast.warn(message);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <DropzoneArea
        clearOnUnmount
        useChipsForPreview
        showPreviewsInDropzone
        showAlerts={false}
        filesLimit={props.maxFiles}
        maxFileSize={props.maxFileSize}
        acceptedFiles={props.acceptedFiles}
        dropzoneText={props.displayText}
        onAlert={onAlert}
        onChange={(files) => props.onChange?.(files)}
        previewGridProps={{
          container: {
            spacing:        1,
            direction:      'row',
            justifyContent: 'center',
            alignItems:     'center',
          },
        }}
      />
    </ThemeProvider>
  );
};

MDropzone.propTypes = {
  maxFiles:      PropTypes.number,
  acceptedFiles: PropTypes.arrayOf(PropTypes.string),
  maxFileSize:   PropTypes.number,
  displayText:   PropTypes.string,
  onChange:      PropTypes.func,
};

MDropzone.defaultProps = {
  maxFiles:      1,
  acceptedFiles: ['text/plain'],
  maxFileSize:   Constants.BinaryOneMBSize * 3,
  displayText:   '',
  onChange:      null,
};

export default MDropzone;
